import { render, staticRenderFns } from "./extended_settings.vue?vue&type=template&id=7ef5de3d&"
import script from "./extended_settings.vue?vue&type=script&lang=js&"
export * from "./extended_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports